import { Component } from '@angular/core';

import { ApiAdminWalletService } from '../../data/services/api/api-admin-wallet.service';
import { WALLET_COLUMNS } from '../../data/constants/wallet.constants';

@Component({
  selector: 'app-admin-details',
  templateUrl: './admin-details.component.html',
  styleUrls: ['./admin-details.component.scss']
})
export class AdminDetailsComponent {
  columns = WALLET_COLUMNS;
  wallet: any = {};
  loading = true
  
  constructor(
    public apiAdminWalletService: ApiAdminWalletService
  ) {
    this.apiAdminWalletService.getAdminWalletAmounts().subscribe(wallet => {
      this.wallet = wallet;
      this.loading = false;
    });
  }
}
